module.exports = __webpack_public_path__ + "static/media/humanitarian-need.8cc1ab63.png";